import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@mui/material';
import React from 'react';
import { ModalProps } from '../../../types/modal';

interface Props extends ModalProps {
    onChange: () => any;
}

const RefreshModal = ({ onChange, open, onClose }: Props) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogTitle>
                Start a new chat
                <IconButton
                    onClick={onClose}
                    size='small'
                    aria-label='close'
                    sx={{ color: 'text.primary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                        fontSize: '14px',
                    }}
                >
                    Are you sure you want to start a new chat?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant='contained' onClick={onChange}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RefreshModal;
